import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const MainDiv = styled.div`
  height: 100vh;
  width: 100vw;
  background: #F7F8F9;
  display: flex;
  color: #1E2228;
`;
export const ColumnDiv = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
`;
export const ContentWrapDiv = styled.div`
  height: calc(100vh - 80px);
  overflow-x: scroll;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
`;
export const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
`;
export const HeaderWrapDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 25px 36px;
  & > div {
    font-size: 24px;
    font-weight: 700;
  }
  & > button {
    background-color: #1B49EA;
    color: #ffffff;
    border-radius: 8px;
    padding: 12px 17px;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    & > div {
      height: 15px;
      overflow: hidden;
      margin-right: 8px;
      font-size: 20px;
      display: flex;
      align-items: center;
    }
  }
`;
export const FilterWrapDiv = styled.div`
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0px 36px;
  margin-bottom: 20px;
  & input {
    width: 115px;
    margin-right: 12px;
  }
  & > div {
    margin-right: 12px;
    &:last-child {
      margin-right: 0px;
    }
  }
`;
export const SearchDiv = styled.div`
  position: relative;
  & img {
    height: 20px;
    width: 20px;
    position: absolute;
    top: 10px;
    left: 10px;
  }
  & input {
    height: 38px;
    width: 200px;
    margin: 0px;
    padding: 0px 12px 0px 40px;
  }
`;
export const CardDiv = styled.div`
  border-radius: 8px;
  margin: 0px 36px auto 36px;
  display: flex;
  flex-wrap: wrap;
  transition: all 0.5s;
  & > div:last-child {
    align-self: flex-start;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  & > div:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
`;
export const QuestionTable = styled.table`
  width: 100%;
  font-size: 14px;
  border-collapse: collapse;
  & th {
    padding: 14px 30px;
    background-color: #EDEFF1;
  }
  & tr {
    border-bottom: 1px solid #ececec;
  }
  & td {
    padding: 24px 30px;
    & > div {
      display: flex;
      align-items: center;
      & > button {
        height: 32px;
        width: 32px;
        background: none;
        padding: 6px;
        border-radius: 4px;
        &:hover {
          background: #edf0fe;
        }
      }
    }
  }
`;
export const UpdateLink = styled(Link)`
  height: 32px;
  width: 32px;
  background: none;
  padding: 6px;
  border-radius: 4px;
  box-sizing: border-box;
  &:hover {
    background: #edf0fe;
  }
`;
export const AddLink = styled(Link)`
  height: 40px;
  background-color: #1B49EA;
  color: #ffffff;
  border-radius: 8px;
  padding: 8px 17px;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  text-decoration: none;
  box-sizing: border-box;
  & > span {
    height: 15px;
    overflow: hidden;
    margin-right: 8px;
    margin-bottom: 3px;
    font-size: 20px;
    display: flex;
    align-items: center;
  }
  &:hover {
    color: #ffffff;
  }
`;
export const ContestWrapDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px;
  border-bottom: 1px solid #ECECEC;
  background: #FFFFFF;
  transition: all 0.5s;
  box-sizing: border-box;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: ${props => props.layout === 'list' ? '0px' : '8px'};
  width: ${props => props.layout === 'list' ? '100%' : '32%'};
  margin: ${props => props.layout === 'list' ? '0px' : `0px ${(props.index + 1) % 3 === 0 ? '0px' : '2%'} 2% 0px`};
`;
export const ContestLeftDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 12px;
  flex-grow: 1;
`;
export const ContestRightDiv = styled.div`
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;
`;
export const ContestHeadDiv = styled.div`
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  color: #1E2228;
`;
export const ContestDetailsP = styled.p`
  font-size: 12px;
  line-height: 15px;
  margin: 10px 0px;
  & > span {
    &:after {
      content: '';
      height: 4px;
      width: 4px;
      border-radius: 4px;
      background-color: #C8CACC;
      margin: 2px 12px;
      display: inline-block;
    }
  }
  & span:last-child {
    &:after {
      display: none;
    }
  }
`;
export const ContestTimeDiv = styled.div`
  display: flex;
  color: #939599;
  font-size: 12px;
  line-height: 15px;
  & div {
    margin-right: 12px;
  }
`;
export const TagSpan = styled.span`
  font-size: 10px;
  text-transform: uppercase;
  padding: 4px 7px;
  border-radius: 4px;
  margin-left: 9px;
  color: ${props => props.tagStyle && props.tagStyle.color};
  background-color: ${props => props.tagStyle && props.tagStyle.backgroundColor};
  border: ${props => props.tagStyle && props.tagStyle.border};
`;
export const PaginationWrapDiv = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 36px;
`;
export const StatusWrapDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 36px 24px 18px;
`;
export const StatusButton = styled.button`
  background: none;
  border: none;
  margin: 0px 18px;
  color: #939599;
  font-size: 16px;
  font-weight: bold;
  padding: 12px 0px;
  border-bottom: 3px solid transparent;
  border-bottom: ${props => props.active ? '3px solid #FF2C91' : '3px solid transparent'};
  color: ${props => props.active ? '#FF2C91' : '#939599'};
`;
export const TooltipSpan = styled.span`
  background: none;
  height: 36px;
  width: 36px;
  position: relative;
  &:hover > div {
    display: block;
  }
  & img {
    height: 16px;
    width: 16px;
    margin-left: 6px;
  }
  & > div {
    max-width: 300px;
    position: absolute;
    padding: 10px 14px;
    border-radius: 12px;
    right: -22px;
    top: 23px;
    z-index: 9;
    font-size: 12px;
    background-color: #1E2228;
    color: #ffffff;
    display: none;
    flex-direction: column;
    &:before {
      content: '';
      height: 12px;
      width: 12px;
      position: absolute;
      transform: rotate(45deg);
      top: -4px;
      right: 24px;
      background-color: #1E2228;
    }
    &:after {
      content: '';
      height: 16px;
      width: 35px;
      position: absolute;
      top: -8px;
      right: 14px;
    }
  }
`;
export const LayoutWrapDiv = styled.div`
  display: flex;
  border-radius: 6px;
  margin-right: 36px;
`;
export const Layout01Button = styled.div`
  width: 46px;
  height: 38px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #C8CACC;
  border-right: 0px solid transparent;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  background: ${props => props.active ? '#EDF0FD' : '#ffffff'};
  margin: 0px;
  cursor: pointer;
  &:before, :after {
    content: '';
    height: 7px;
    width: 16px;
    background-color: ${props => props.active ? '#1B49EA' : '#939599'};
    border-radius: 2px;
    flex-shrink: 0;
    margin: 1px;
  }
`;
export const Layout02Button = styled.div`
  width: 46px;
  height: 38px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  border: 1px solid #C8CACC;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  margin: 0px;
  background: ${props => props.active ? '#EDF0FD' : '#ffffff'};
  cursor: pointer;
  & > div {
    display: flex;
    align-items: center;
    &:before, :after {
      content: '';
      height: 7px;
      width: 7px;
      background-color: ${props => props.active ? '#1B49EA' : '#939599'};
      border-radius: 2px;
      flex-shrink: 0;
      margin: 1px;
    }
  }
`;
